module.exports = __webpack_public_path__ + "img/page_5_01.71017d1e.png";